export default __webpack_public_path__ + "static/media/clientImg5.039d3de9.png";